// extracted by mini-css-extract-plugin
export default {"base":"TextBoxFilter_base__fqnXM"};